<script setup lang="ts">
import type { ImageProps } from '~/types';

defineProps<{ image: ImageProps }>();
</script>

<template>
  <SwiperSlide>
    <AppSwiperSlideBase class="aspect-4/3 w-full lg:aspect-1051/547">
      <img :src="image.url" :alt="image.alt" class="size-full object-cover" />
    </AppSwiperSlideBase>
  </SwiperSlide>
</template>
